import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import { Modal, Button, Form, Tabs, Tab, Col, Row } from "react-bootstrap";
import { FaDownload, FaEdit, FaEye, FaFileExcel, FaTrash } from "react-icons/fa";
import axios from "axios";
import Swal from "sweetalert2";
import "./intership.css";

// const API_URL = "http://localhost:8000/internship.php";

const API_URL = "https://crm.fazoacademy.in/php/internship.php";




const today = new Date().toISOString().split('T')[0];

function Internship({ onLogout }) {
  const [courses, setCourses] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedMentor, setSelectedMentor] = useState(null);

  // edit 
  const [showEditModal, setShowEditModal] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);


  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    coursedetails: "",
    date: today,
    fees: "",
    location: "",
    yop: "",
    degree: "",
    percentage: "",
  })

  const [edit, setEdit] = useState({
    id:null,
     name: "",
    email: "",
    phone: "",
    coursedetails: "",
    date: "",
    fees: "",
    location: "",
    yop: "",
    degree: "",
    percentage: "",
  })

  const [searchQuery, setSearchQuery] = useState("");







  useEffect(() => {
    fetchCourses();
    // fetchStudent();
  }, []);



  const fetchCourses = async () => {
    try {
      const response = await axios.get(API_URL);
      const jsonString = response.data.substring(response.data.indexOf("["));
      const parsedData = JSON.parse(jsonString);
      setCourses(Array.isArray(parsedData) ? parsedData : []);
    } catch (error) {
      console.error("Error fetching courses:", error);
      setCourses([]);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };


const handleAddCourse = async () => {
  const trimmedName = formData.name.trim();
  const trimmedEmail = formData.email.trim();
  const trimmedPhone = formData.phone.trim();
  const trimmedCourse = formData.coursedetails.trim();
  const trimmedDate = formData.date.trim();
  const trimmedYop = formData.yop.trim();
  const trimmedLocation = formData.location.trim();
  const trimmedFees = formData.fees.trim();
  const trimmedDegree = formData.degree.trim();
  const trimmedPercentage = formData.percentage.trim();

  if (
    !trimmedName ||
    !trimmedPhone ||
    !trimmedDate ||
    !trimmedDegree ||
    !trimmedCourse ||
    !trimmedFees ||
    !trimmedPercentage ||
    !trimmedEmail ||
    !trimmedYop ||
    !trimmedLocation
  ) {
    Swal.fire({
      icon: "warning",
      title: "Field EMPTY",
      text: "Please fill all the fields",
    });
    return;
  }

  if (courses.some(enquiry => enquiry.phone === trimmedPhone)) {
    Swal.fire({
      icon: "error",
      title: "Duplicate Phone",
      text: "This phone number is already registered!",
    });
    return;
  }

  try {
    await axios.post(API_URL, {
      name: trimmedName,
      email: trimmedEmail,
      phone: trimmedPhone,
      date: trimmedDate,
      coursedetails: trimmedCourse,
      fees: trimmedFees,
      degree: trimmedDegree,
      percentage: trimmedPercentage,
      yop: trimmedYop,
      location: trimmedLocation
    });

    fetchCourses();
    setFormData({
      name: "",
      email: "",
      phone: "",
      coursedetails: "",
      date: today,
      fees: "",
      degree: "",
      percentage: "",
      yop: "",
      location: ""
    });
    console.log(formData);

    setShowAddModal(false)
    Swal.fire({
      icon: "success",
      title: "Success!",
      text: " Added successfully!",
      showConfirmButton: false,
      timer: 2000,
    });
  } catch (error) {
    console.error("Error adding course:", error);
    Swal.fire({
      icon: "error",
      title: "Oops!",
      text: "Failed to add course.",
    });
  }
};

const handleEditCourse = async () => {
  const trimmedName = edit.name.trim();
  const trimmedEmail = edit.email.trim();
  const trimmedPhone = edit.phone.trim();
  const trimmedCourse = edit.coursedetails.trim();
  const trimmedDate = edit.date.trim();
  const trimmedYop = edit.yop.trim();
  const trimmedLocation = edit.location.trim();
  const trimmedFees = edit.fees.trim();
  const trimmedDegree = edit.degree.trim();
  const trimmedPercentage = edit.percentage.trim();

  if (
    !trimmedName ||
    !trimmedPhone ||
    !trimmedDate ||
    !trimmedDegree ||
    !trimmedCourse ||
    !trimmedFees ||
    !trimmedPercentage ||
    !trimmedEmail ||
    !trimmedYop ||
    !trimmedLocation
  ) {
    Swal.fire({
      icon: "warning",
      title: "Field EMPTY",
      text: "Please fill all the fields",
    });
    return;
  }

  try {
    await axios.put(`${API_URL}`, {
      id: edit.id, // send id explicitly
      name: trimmedName,
      email: trimmedEmail,
      phone: trimmedPhone,
      coursedetails: trimmedCourse,
      date: trimmedDate,
      yop: trimmedYop,
      location: trimmedLocation,
      fees: trimmedFees,
      degree: trimmedDegree,
      percentage: trimmedPercentage,
    });

    fetchCourses();
    setShowEditModal(false);
    Swal.fire({
      icon: "success",
      title: "Updated!",
      text: "Course updated successfully!",
      showConfirmButton: false,
      timer: 2000,
    });
  } catch (error) {
    console.error("Error updating course:", error);
    Swal.fire({
      icon: "error",
      title: "Oops!",
      text: "Failed to update course.",
    });
  }
};

  const handleDeleteCourse = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`${API_URL}?id=${id}`);
          fetchCourses();
          Swal.fire("Deleted!", "Mentor deleted successfully.", "success");
        } catch (error) {
          console.error("Delete error:", error);
          Swal.fire("Error", "Failed to delete mentor.", "error");
        }
      }
    });
  };





  const handleExportToExcel = () => {
    window.open(`${API_URL}?export=excel`, "_blank");
  };

  const filteredCourses = courses.filter((course) =>
    course.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    course.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
    course.phone.toLowerCase().includes(searchQuery.toLowerCase()) ||
    course.coursedetails.toLowerCase().includes(searchQuery.toLowerCase()) ||
    course.fees.toLowerCase().includes(searchQuery.toLowerCase()) ||
    course.location.toLowerCase().includes(searchQuery.toLowerCase()) ||
    course.degree.toLowerCase().includes(searchQuery.toLowerCase()) ||
    course.percentage.toLowerCase().includes(searchQuery.toLowerCase())

  );  


  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentCourses = filteredCourses.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div className="course-container">
      <div className="navigation">
        <a href="#">Internship</a> / <a href="#" onClick={onLogout}>Logout</a>
      </div>

      <div className="add-course">
        <button onClick={() => setShowAddModal(true)} className="add-btn">Add new Internship +</button>
      </div>

      <div className="d-flex justify-content-between">


        {/* Items per page selection */}
        <Form.Select
          value={itemsPerPage}
          onChange={(e) => setItemsPerPage(Number(e.target.value))}
          className="pagination-select"
        >
          <option value="10">Show 10</option>
          <option value="20">Show 20</option>
          <option value="30">Show 30</option>
        </Form.Select>

        <div className="search-container">
          <Form.Control
            type="text"
            placeholder="Search "
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search-input"
          />
        </div>

        <Button onClick={handleExportToExcel} className="excel-btn">
          <FaFileExcel className="excel-icon" /> Export to Excel
        </Button>

      </div>
      <Table striped bordered hover className="course-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th> Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Course</th>
            <th>Date</th>
            <th>Fees</th>
            <th>Location</th>
            <th>Degree</th>
            <th>Percentage</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentCourses.length === 0 ? (
            <tr>
              <td colSpan="7" className="text-center text-danger">
                No details found
              </td>
            </tr>
          ) : (
            currentCourses.map((course, index) => (
              <tr
                key={course.id}
                className={course.status === "Active" ? "table-success" : "table-danger"}
              >
                <td>{indexOfFirstItem + index + 1}</td>
                <td>{course.name}</td>
                <td>{course.email}</td>
                <td>{course.phone}</td>
                <td>{course.coursedetails}</td>
                <td>{course.date}</td>
                <td>{course.fees}</td>
                <td>{course.location}</td>
                <td>{course.degree}</td>
                <td>{course.percentage}%</td>

                <td>
                  {course.status === "Active" && (
                    <>

                      <FaEdit
                        className="edit-icon"
                      onClick={() => {
                        setEdit(course);
                        setShowEditModal(true);
                      }}
                      />
                      <FaTrash
                        className="delete-icon"
                        onClick={() => handleDeleteCourse(course.id)}
                      /> &nbsp;

                      <FaEye className="view-icon"
                      //  onClick={() => handleViewDetail(course)}
                      />
                    </>

                  )}
                </td>

              </tr>
            )))}
        </tbody>

      </Table>

      {/* Pagination Controls */}
      <div className="pagination-controls">
        <Button variant="secondary" onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))} disabled={currentPage === 1}>
          Previous
        </Button>
        <span className="page-number">Page {currentPage}</span>
        <Button
          variant="secondary"
          onClick={() => setCurrentPage((prev) => prev + 1)}
          disabled={indexOfLastItem >= filteredCourses.length}
        >
          Next
        </Button>
      </div>

      {/* Add Mentor Modal */}
      <Modal show={showAddModal} onHide={() => setShowAddModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Internship Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group as={Row} className="mb-3" controlId="formName">
              <Form.Label column sm={3}>Name</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter name"
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="formEmail">
              <Form.Label column sm={3}>Email</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter email"
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="formPhone">
              <Form.Label column sm={3}>Phone</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="text"
                  value={formData.phone}
                  onChange={(e) => {
                    const input = e.target.value;
                    if (/^\d{0,10}$/.test(input)) {
                      handleChange({ target: { name: 'phone', value: input } });
                    }
                  }}
                  placeholder="Enter Mobile Number"
                  required
                />
                {formData.phone.length > 0 && formData.phone.length !== 10 && (
                  <div style={{ color: 'red', marginTop: '5px' }}>
                    Enter Valid Phone Number.
                  </div>
                )}
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="formName">
              <Form.Label column sm={3}>Location</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="text"
                  name="location"
                  value={formData.location}
                  onChange={handleChange}
                  placeholder="Enter location"
                />
              </Col>
            </Form.Group>


            <Form.Group as={Row} className="mb-3" controlId="formDate">
              <Form.Label column sm={3}>Date</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="date"
                  name="date"
                  value={formData.date}
                  onChange={handleChange}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="formFees">
              <Form.Label column sm={3}>Fees</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="text"
                  name="fees"
                  value={formData.fees}
                  onChange={(e) => {
                    const input = e.target.value;
                    if (/^\d{0,6}$/.test(input)) {
                      handleChange({ target: { name: 'fees', value: input } });
                    }
                  }}
                  placeholder="Enter fees"
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="formEnquiry">
              <Form.Label column sm={3}>Course Name</Form.Label>
              <Col sm={9}>
                <Form.Control
                  as="select"
                  name="coursedetails"
                  value={formData.coursedetails}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="Front End Development">Front End Development</option>
                  <option value="Java Full Stack">Java Full Stack</option>
                  <option value="Data Science">Data Science</option>
                  <option value="Python Full Stack">Python Full Stack</option>
                  <option value="Web Development">Web Development</option>
                  <option value="UI/UX Course">UI/UX Course</option>
                  <option value="Backend Development">Backend Development</option>
                  <option value="Web Design Course">Web Design Course</option>
                  <option value="Java Course">Java Course</option>
                  <option value="Python Course">Python Course</option>

                </Form.Control>
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="formYop">
              <Form.Label column sm={3}>YOP</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="text"
                  name="yop"
                  value={formData.yop}
                  onChange={(e) => {
                    const input = e.target.value;
                    if (/^\d{0,4}$/.test(input)) {
                      handleChange({ target: { name: 'yop', value: input } });
                    }
                  }}
                  placeholder="Enter Year of Passing"
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formDegree">
              <Form.Label column sm={3}>Degree</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="text"
                  name="degree"
                  value={formData.degree}
                  onChange={(e) => {
                    const input = e.target.value;
                    // Allow only alphabets and spaces, max 50 characters
                    if (/^[a-zA-Z\s]{0,50}$/.test(input)) {
                      handleChange({ target: { name: 'degree', value: input } });
                    }
                  }}
                  placeholder="Enter Degree"
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formPercentage">
              <Form.Label column sm={3}>Percentage</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="text"
                  name="percentage"
                  value={formData.percentage}
                  onChange={(e) => {
                    const input = e.target.value;
                    // Regex: optional % at end, allow 0-3 digits, optional . and 0-2 decimals
                    if (/^\d{0,3}(\.\d{0,2})?%?$/.test(input)) {
                      handleChange({ target: { name: 'percentage', value: input } });
                    }
                  }}
                  placeholder="Enter Percentage (e.g. 85.5%)"
                />
              </Col>
            </Form.Group>

          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAddModal(false)}>
            Cancel
          </Button>
          <Button variant="success"
          onClick={handleAddCourse}
          >
            Add Details
          </Button>
        </Modal.Footer>
      </Modal>


      <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Internship Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group as={Row} className="mb-3" controlId="formName">
              <Form.Label column sm={3}>Name</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="text"
                  name="name"
                  value={edit.name}
                  onChange={(e) => setEdit({ ...edit, name: e.target.value })}

                  placeholder="Enter name"
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="formEmail">
              <Form.Label column sm={3}>Email</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="email"
                  name="email"
                    value={edit.email}
                  onChange={(e) => setEdit({ ...edit, email: e.target.value })}
                  placeholder="Enter email"
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="formPhone">
              <Form.Label column sm={3}>Phone</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="text"
                  value={edit.phone}
                  onChange={(e) => {
                    const input = e.target.value;
                    if (/^\d{0,10}$/.test(input)) {
                   setEdit({...edit, phone:input})
                    }
                  }}
                  placeholder="Enter Mobile Number"
                  required
                />
                {formData.phone.length > 0 && formData.phone.length !== 10 && (
                  <div style={{ color: 'red', marginTop: '5px' }}>
                    Enter Valid Phone Number.
                  </div>
                )}
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="formName">
              <Form.Label column sm={3}>Location</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="text"
                  name="location"
                value={edit.location}
                  onChange={(e) => setEdit({ ...edit, location: e.target.value })}
                  placeholder="Enter location"
                />
              </Col>
            </Form.Group>


            <Form.Group as={Row} className="mb-3" controlId="formDate">
              <Form.Label column sm={3}>Date</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="date"
                  name="date"
                value={edit.date}
                  onChange={(e) => setEdit({ ...edit, date: e.target.value })}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="formFees">
              <Form.Label column sm={3}>Fees</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="text"
                  name="fees"
                  value={edit.fees}
                  onChange={(e) => {
                    const input = e.target.value;
                    if (/^\d{0,6}$/.test(input)) {
                      // handleChange({ target: { name: 'fees', value: input } });
                      setEdit({...edit, fees:input})
                    }
                  }}
                  placeholder="Enter fees"
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="formEnquiry">
              <Form.Label column sm={3}>Course Name</Form.Label>
              <Col sm={9}>
                <Form.Control
                  as="select"
                  name="coursedetails"
                  value={edit.coursedetails}
                  onChange={(e) => setEdit({...edit, coursedetails:e.target.value})}
                >
                  <option value="">Select</option>
                  <option value="Front End Development">Front End Development</option>
                  <option value="Java Full Stack">Java Full Stack</option>
                  <option value="Data Science">Data Science</option>
                  <option value="Python Full Stack">Python Full Stack</option>
                  <option value="Web Development">Web Development</option>
                  <option value="UI/UX Course">UI/UX Course</option>
                  <option value="Backend Development">Backend Development</option>
                  <option value="Web Design Course">Web Design Course</option>
                  <option value="Java Course">Java Course</option>
                  <option value="Python Course">Python Course</option>

                </Form.Control>
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="formYop">
              <Form.Label column sm={3}>YOP</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="text"
                  name="yop"
                  value={edit.yop}
                  onChange={(e) => {
                    const input = e.target.value;
                    if (/^\d{0,4}$/.test(input)) {
                      setEdit({ ...edit, yop:input });
                    }
                  }}
                  placeholder="Enter Year of Passing"
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formDegree">
              <Form.Label column sm={3}>Degree</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="text"
                  name="degree"
                  value={edit.degree}
                  onChange={(e) => {
                    const input = e.target.value;
                    // Allow only alphabets and spaces, max 50 characters
                    if (/^[a-zA-Z\s]{0,50}$/.test(input)) {
                      setEdit({ ...edit, degree:input});
                    }
                  }}
                  placeholder="Enter Degree"
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formPercentage">
              <Form.Label column sm={3}>Percentage</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="text"
                  name="percentage"
                  value={edit.percentage}
                  onChange={(e) => {
                    const input = e.target.value;
                    // Regex: optional % at end, allow 0-3 digits, optional . and 0-2 decimals
                    if (/^\d{0,3}(\.\d{0,2})?%?$/.test(input)) {
                      setEdit({ ...edit, percentage:input });
                    }
                  }}
                  placeholder="Enter Percentage (e.g. 85.5%)"
                />
              </Col>
            </Form.Group>

          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditModal(false)}>
            Cancel
          </Button>
          <Button variant="success"
          onClick={handleEditCourse}
          >
            Add Details
          </Button>
        </Modal.Footer>
      </Modal>





    </div>
  );
}

export default Internship;
